export const IMAGES_URL = process.env.REACT_APP_APP_RESOURCES;
export const SC_KEY = "xFzrd=%#/.1c[mT@ak1TVl6<L(TWT=o2$lB7uQsK+A0n^b>+QS[/F~s%CJQbs";
export const API_URL = process.env.REACT_APP_API_URL;
export const USER_TOKEN = process.env.REACT_APP_APP_USERS_URL;
